import React from "react";
import { Link } from "react-router-dom";
import banner from "../../assests/banner.jpg";
import Button from "../Shared/Button";

const Banner = () => {
  return (
    <header>
      <div className="min-h-screen ">
        <div className="grid grid-cols-1 lg:order-last lg:grid-cols-2 max-w-7xl items-center justify-items-center my-28">
          <img
            src={banner}
            className="w-80 md:w-3/4 hover:shadow-2xl duration-300 hover:scale-105 rounded-full animate-bounce"
            alt="avatar"
          />
          <div className=" md:max-w-2xl">
            <div className="w-80 md:w-96 pt-12 lg:pt-2">
              <h1 className="text-6xl font-BebasNeue">
                Fuad mahmud <br /> thakur saad
              </h1>
              <h2 className="text-2xl font-Poppins">Junior Web Developer</h2>
              <hr className="border-b-2 border-t-0 pt-2 border-neutral" />
              <p className="py-6 font-Poppins">
                I am a passionate developer who is always enthusiastic about
                learning new technologies.
              </p>
              <div className="flex">
                <a
                  href="https://drive.google.com/file/d/1725_S91ASIS5HuXY5auCcNiGec7t6dJQ/view?usp=sharing"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Button>Resume</Button>
                </a>
                <Link to="contact" className="ml-4">
                  <Button bgColor="btn-secondary">Contact Me</Button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Banner;
